export default __webpack_public_path__ + "static/media/top_web_banner_SimplyCLICK.9dea054d.png";